import axios from '@axios'
import { useApiAWS } from '@/composables/useApi'

const apiAws = useApiAWS()

export default {
  namespaced: true,
  state: {
    item: {
      item_nome: '',
      item_descricao: 'F',
      id_categoria: '',
      ativo: null,
      imagens: [],
    },
    items: [],
  },
  getters: {
    GET_ITEMS(state) {
      return state.items
    },
    GET_IMAGENS_ITEM(state) {
      return state.item.imagens
    },
  },
  mutations: {
    SET_PRODUTO_DATA(state, cliente) {
      state.cliente = cliente
    },
    SET_IMAGE_PRODUTO_DATA(state, image) {
      state.item.imagens.push(image)
    },
    REMOVE_IMAGE_PRODUTO_DATA(state, iamge) {
      const index = state.item.imagens.indexOf(iamge)
      state.item.imagens.splice(index, 1)
    },
    SET_ITEM_DATA(state, item) {
      state.item = item
    },
  },
  actions: {
    findAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/linkafiliado', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    createImageItem(ctx, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/imagens', formData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    createVariasImageItem(ctx, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/imagens/variasImagens', formData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    uploadImages(ctx, { formData }) {
      return new Promise((resolve, reject) => {
        apiAws
          .post('/upload', formData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
  },
}
